import { Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, ValidateNested } from 'class-validator';

import { CountrySubdivisionInputDto } from './country-subdivision-input.dto';

export class UpdateCountryDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  code?: string;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CountrySubdivisionInputDto)
  subdivisions?: CountrySubdivisionInputDto[];
}
